import { defineMessages } from 'utils/intl';

export default defineMessages({
  complexDeliveryTitle: 'Przy kompleksowej obsłudze proponujemy:',
  publicSectorTitle: 'Instytucjom publicznym oferujemy:',
  calendarTitle: 'odroczone terminy płatności',
  calendarSubtitle: 'już od pierwszego zamówienia',
  vatTitle: 'stawkę VAT 0%\n\n',
  vatSubtitle: 'dla szkół i uczelni, zgodnie z aktualnymi przepisami',
  pocketTitle: 'finansowanie i płatność',
  pocketSubtitle: 'indywidualnie ustalone terminy i formy płatności',
  headphoneTitle: 'opiekę przed i pozakupową',
  headphoneSubtitle: 'demo, wsparcie techniczne',
  priceTitle: 'ceny\nprojektowe',
  priceSubtitle: 'w zależności od wartości zamówienia',
  protectTitle: 'bezpieczeństwo zakupu',
  protectSubtitle: 'urządzenia z oficjalnych kanałów dystrybucji',
});
